import { z } from "zod";

/**
 * The programme allowlist (spec v1.8: Nursing only; PT, OT, PA, RT and Radiography removed in plan BE18).
 * Anything else goes to the waitlist.
 */
export const PROGRAMME_CODES = ["nursing"] as const;
export const programmeCodeSchema = z.enum(PROGRAMME_CODES);
export type ProgrammeCode = z.infer<typeof programmeCodeSchema>;

/** Exam variants (spec §13.4a). One code can have several date-versioned exam_configs rows (e.g. 2023 and 2026 plans). */
export const EXAM_CODES = ["nclex_rn", "nclex_pn"] as const;
export const examCodeSchema = z.enum(EXAM_CODES);
export type ExamCode = z.infer<typeof examCodeSchema>;

/** Short display names for exam pickers shown before sign-in (full configs need an account). */
export const EXAM_NAMES: Record<ExamCode, string> = {
  nclex_rn: "NCLEX-RN",
  nclex_pn: "NCLEX-PN",
};

export const programmeSchema = z.object({
  code: programmeCodeSchema,
  name: z.string().min(1),
  short_name: z.string().min(1),
  exam_label: z.string().min(1),
  exam_codes: z.array(examCodeSchema).min(1),
  active: z.boolean(),
  sort_order: z.number().int(),
});
export type Programme = z.infer<typeof programmeSchema>;
